import { Inline } from "../Inline";
import React from 'react';
import styled from 'styled-components';
export function DialogActions(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Inline, {
    gap: 8
  }, children));
}
var Container = styled.div.withConfig({
  displayName: "DialogActions__Container",
  componentId: "vapor__sc-1qh3myf-0"
})(["margin-left:auto;"]);